import { render, staticRenderFns } from "./SzamlazzhuForm.vue?vue&type=template&id=42080205&"
import script from "./SzamlazzhuForm.vue?vue&type=script&lang=js&"
export * from "./SzamlazzhuForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports